import { SUSPENSE_WRAPPER } from "../../common/components/SuspenseWrapper/SuspenseWrapper";
import { SKELETON_LOADER_LAYOUT_PAGE } from "../../constants/constant";
import { Step } from "../../Interface/scheduler/form";
import PaymentApiFramePage from "./components/PaymentApiIframePage";
import PaymentIframePage from "./components/PaymentIframePage";
interface PaymentIframePageProps {
  config?: Step;
}

const PaymentPage = ({ config }: PaymentIframePageProps) => {
  if (config?.paymentAPI) {
    return SUSPENSE_WRAPPER(
      <PaymentApiFramePage config={config} />,
      SKELETON_LOADER_LAYOUT_PAGE,
    );
  } else if (config?.paymentUrl) {
    return SUSPENSE_WRAPPER(
      <PaymentIframePage config={config} />,
      SKELETON_LOADER_LAYOUT_PAGE,
    );
  }
  return null;
};

export default PaymentPage;
